var currencySymbolMap = require('./map')

module.exports = function getSymbolFromCurrency (currencyCode) {
  if (typeof currencyCode !== 'string') return undefined
  var code = currencyCode.toUpperCase()
  if (!currencySymbolMap.hasOwnProperty(code)) return undefined
  return currencySymbolMap[code]
}

module.exports.currencySymbolMap = currencySymbolMap



//////////////////
// WEBPACK FOOTER
// ./~/currency-symbol-map/currency-symbol-map.js
// module id = 914
// module chunks = 0